import React, { useEffect, useContext } from 'react';
import { UserOrderContext } from 'context/context';
import SearchStoreInsideModal from '../Presentation/SearchStoreInsideModal';
import START_ORDER_CONSTANTS from '../../../StartOrderComponent/Constants/startOrderConstants';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import { getDistanceFromGoogleMatrix, calculateStoreDistance } from '../SearchStoreUtilities/geoUtils';
import geoLocation from '@kfc-global/react-shared/utils/geoLocation.js';
import {
  setGeoHashCount,
  getBulkStoreStatus,
  resetStores,
  getFavoriteBulkStoreStatus,
} from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { setLocalisedSignInAnalyticsData, sortPolygonsStores } from '../SearchStoreUtilities/SearchStoreUtils';
import { useSelector, useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '@kfc-global/react-shared/redux/Actions/LoaderAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getDispositionTypeOnAPIFormat,
  isValidValue,
  getValueOrDefaultObject,
  getValueOrEmptyString,
  getTernaryValue,
  createPayloadForStatusCall,
  recursiveAndCheck,
  getAndCheck,
  isCateringDisposition,
  isDeliveryDisposition,
} from 'common/utilities/utils';
import { ChannelManager } from 'common/manager';
import { login } from 'common/utilities/LoginUtils';
import SEARCHSTORE_MODULE_DATA from '../Data/Defaults';
import SearchStore from './SearchStore';
import { FORM, searchStoreConfig } from 'organisms/SearchStore/AU/Config/searchStore.config';
import { DISPOSITION_KEYS, LOCAL_STORAGE_KEYS, PICK_UP, ROUTE_URL, OPEN } from 'common/constants/SharedConstants';
import { useAppDispatch } from '@kfc-global/react-shared/redux/Store/hooks';
import { resetPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';

export const filterStores = (storeList, enableClickCollectScheduleOrder = false) => {
  return storeList.filter(store => {
    return (
      store?.id &&
      store?.location?.latitude &&
      store?.location?.longitude &&
      (enableClickCollectScheduleOrder && isDeliveryDisposition(store?.service)
        ? store?.summary?.status?.currentStatus === OPEN
        : store?.summary?.status?.currentStatus) &&
      store?.summary?.menu?.catalogs?.length &&
      store?.summary?.timings?.operatingHours?.length > 0 &&
      store?.summary?.timings?.asap
    );
  });
};
export const SearchStoreModule = props => {
  const { contentData = {}, onStoreSelectFinish, finAKFCContentData = {}, isMobile = false } = props;
  const {
    SEARCH_ORDER_DATA,
    DISPOSITION_DATA,
    ANALYTICS_LOCALISATION_SIGNIN,
    SET_ELIGIBLE_STORE,
    SET_FIND_A_KFC_VIEW,
    SET_REDIRECTION_PATH,
    REORDER_MODAL_OPEN,
    FROM_REORDER_MODAL_OPEN,
    REORDER_STORE_CHANGED,
    FAV_STORE_NOT_IN_RADIUS
  } = START_ORDER_CONSTANTS;
  const { DELIVERY, PICKUP } = DISPOSITION_KEYS;
  const dispatch = useDispatch();
  const sliceDispatch = useAppDispatch();
  const { FORMATTED_DELIVERY_ADDRESS, SELECTED_LINE_ADDRESS_VAL, SELECTED_FAV_ADDRESS,IS_FAV_ADDRESS_SELECTED } = SEARCH_STORE_CONSTANTS;

  // get the context from parent
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { dispositionStateData, searchStoreData, findAKFC } = userOrderState;
  const { dispositionType = localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_TYPE) } =
    getValueOrEmptyString(dispositionStateData);
  const {
    storeSearch = {},
    tenantId,
    countryCode = [],
    componentOptions,
    storelocatormaxreturncount = 10,
    ispolygonrequired,
  } = useSelector(data => getValueOrDefaultObject(data.tenantReducer));
  const { storeSelection, web = {} } = componentOptions;
  const { shouldCheckDropOffAddress = false } = web;
  const dispositionConfig = componentOptions?.web?.dispositionConfig;
  const enableClickCollectScheduleOrder = componentOptions?.web?.dispositionConfig?.enableClickCollectScheduleOrder;
  const {
    currentMarket = countryCode?.[0]?.toUpperCase(),
    storeCardLimit = storelocatormaxreturncount,
    configSearchScreen = localStorage.getItem(LOCAL_STORAGE_KEYS.CONFIG_SEARCH_SCREEN),
  } = searchStoreData;
  const configSearchKey = `${dispositionType.toUpperCase()}_${configSearchScreen}`;

  const { modalHeaderTitle, shouldShowDisposition, shouldShowSearchStore } = {
    ...searchStoreConfig?.[configSearchKey],
    ...dispositionConfig?.[configSearchKey],
  };
  const headerTitle = modalHeaderTitle;

  const { searchStoreModalContent = {} } = contentData;

  const {
    formContent = {},
    locationsContent: { storeData = [] },
  } = searchStoreModalContent;
  // state variable to store all eligible store informations
  const [eligibleStoreData, seteligibleStoreData] = React.useState([]);
  const [userLocation, setUserLocation] = React.useState({});
  const [eligibleFavoriteStoreData, setEligibleFavoriteStoreData] = React.useState([]);
  const [nearByStores, setNearByStores] = React.useState([]);

  const {
    allStores = [],
    storesWithStatus = [],
    favoriteStoresWithStatus,
    storesUpdated,
  } = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const {
    maxDriveTimeMins,
    distanceMetrics,
    maxDeliveryDistanceMtrs,
    maxPickupDistanceMtrs,
    maxCateringDistanceMtrs,
    geohashprecision,
    boundingBoxSizeMeters,
    shouldCallGoogleDistanceApi,
    numOfStoresToShowDelivery,
    boundingBoxSizeDivider,
  } = storeSearch;
  /**
   * Method to handle close button click on modal behavior
   */
  const handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SET_CART_CLEAR);
    localStorage.setItem(LOCAL_STORAGE_KEYS.RENDER_COMP, true);
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: false } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({ type: SET_REDIRECTION_PATH, value: { redirectionOrder: '' } });
    userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: false } });
    userOrderStateDispatch({ type: FROM_REORDER_MODAL_OPEN, value: { fromReorderFlag: false } });
    userOrderStateDispatch({ type: REORDER_STORE_CHANGED, value: { storeChanged: false } });
    userOrderStateDispatch({
      type: SET_FIND_A_KFC_VIEW,
      value: { findAKFC: window.location.pathname === ROUTE_URL.FIND_STORE },
    });
    sliceDispatch(resetPWAstorage({key:FORMATTED_DELIVERY_ADDRESS}));
    sliceDispatch(resetPWAstorage({key:SELECTED_FAV_ADDRESS}));
    sliceDispatch(resetPWAstorage({key:SELECTED_LINE_ADDRESS_VAL}));
    sliceDispatch(resetPWAstorage({key:IS_FAV_ADDRESS_SELECTED}));
    userOrderStateDispatch({
      type: FAV_STORE_NOT_IN_RADIUS,
      value: {
        showNotInRadiusError: false,
        notInRadiusRestaurant: '',
      },
    });
    
  };

  useEffect(() => {
    const closeSearchStoreModal = eventOfSeachStoreModal => {
      if (eventOfSeachStoreModal.keyCode === 27) {
        handleClose(eventOfSeachStoreModal);
      }
    };
    window.addEventListener('keydown', closeSearchStoreModal);
    return () => {
      window.removeEventListener('keydown', closeSearchStoreModal);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Method to handle go back button click on modal behavior
   */
  const handleGoBackGlobal = event => {
    event.stopPropagation();
    event.preventDefault();
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: shouldShowDisposition } });
    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: {
        showSearchStore: shouldShowSearchStore,
        configSearchScreen: FORM,
        searchedPlaceNonLocalized: searchStoreData?.searchedPlaceNonLocalized,
      },
    });
  };
  /**
   *
   * @param {*} event - event on link clicking
   */
  const singInClickhandler = event => {
    event.stopPropagation();
    event.preventDefault();
    localStorage.setItem(ANALYTICS_LOCALISATION_SIGNIN, JSON.stringify(true));
    setLocalisedSignInAnalyticsData();
    login();
  };
  const { favouriteStores, savedAddresses } = useSelector(data => data.profileReducer);
  const { localized = false } = useSelector(data => data.appStateReducer?.userStatus);

  useEffect(() => {
    const isStoresUpdationCompleted = recursiveAndCheck(allStores.length > 0, storesUpdated);
    isStoresUpdationCompleted && validateNearBystoreResponse(allStores);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allStores, storesUpdated, favouriteStores?.length, userLocation]);

  useEffect(() => {
    storesWithStatus.length > 0 && filterStatusCallResponse(storesWithStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesWithStatus]);

  useEffect(() => {
    const sortedFavoriteStoresData = favoriteStoresWithStatus?.sort(
      (storeA, storeB) => storeA?.distance?.distance?.value - storeB?.distance?.distance?.value,
    );
    setEligibleFavoriteStoreData(sortedFavoriteStoresData);
  }, [favoriteStoresWithStatus]);

  useEffect(() => {
    recursiveAndCheck(dispositionType?.toUpperCase() === DELIVERY, shouldCallGoogleDistanceApi) &&
      googleDistanceAPI(nearByStores);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nearByStores]);

  useEffect(() => {
    return () => {
      dispatch(resetStores());
    };
  }, [findAKFC, dispatch]);
  /**
   * method to get user's lat long values
   */
  const getUserLatLong = userPosition => {
    //pass delivery time limit after converting to seconds
    dispatch(showLoader());
    dispatch(resetStores());
    setUserLocation({ userLat: userPosition.userLat, userLong: userPosition.userLong });
    eligibleStoreData && seteligibleStoreData([]);
    getNearbyStores(userPosition.userLat, userPosition.userLong);

    setTimeout(() => {
      dispatch(hideLoader());
    }, 2000);
  };

  //Method to get nearBystores
  const getNearbyStores = (lat, lon) => {
    const calculateGHPayload = {
      lat: lat,
      lon: lon,
      distanceFromCurrentLoc: boundingBoxSizeMeters / boundingBoxSizeDivider,
      geohashprecision: geohashprecision,
    };
    const geoHash = geoLocation.calculateGH(calculateGHPayload);
    dispatch(setGeoHashCount(geoHash?.length));
  };

  //Method to validate nearBystores
  const validateNearBystoreResponse = allStoresData => {
    const serviceType = getDispositionTypeOnAPIFormat(dispositionType.toUpperCase());
    let validatedNearBystoresData = allStoresData.filter(store => {
      return (
        isValidValue(store.id) && isValidValue(store?.location?.latitude) && isValidValue(store?.location?.longitude)
      );
    });
    if (isDeliveryDisposition(dispositionType) && ispolygonrequired) {
      validatedNearBystoresData = sortPolygonsStores(validatedNearBystoresData, userLocation);
    }
    //calculate linear Distance
    const linearDistancePayload = {
      stores: validatedNearBystoresData,
      disposition: serviceType,
      distanceMetrics: distanceMetrics,
      driveTime: maxDriveTimeMins,
      distanceInMtrs: getTernaryValue(
        dispositionType.toUpperCase() === DELIVERY,
        maxDeliveryDistanceMtrs,
        getTernaryValue(
          dispositionType.toUpperCase() === DISPOSITION_KEYS.PICKUP,
          maxPickupDistanceMtrs,
          maxCateringDistanceMtrs,
        ),
      ),
      noOfStores: getTernaryValue(
        dispositionType.toUpperCase() === DELIVERY,
        numOfStoresToShowDelivery,
        validatedNearBystoresData.length,
      ),
      channel: ChannelManager.channel,
    };
    const linearDistance = geoLocation.checkAndProceed(linearDistancePayload);

    //In order to merge
    setNearByStores(linearDistance);

    //conditionally call  google API
    if (linearDistance) {
      recursiveAndCheck(dispositionType.toUpperCase() === DELIVERY, shouldCallGoogleDistanceApi)
        ? googleDistanceAPI(linearDistance)
        : callStatusAPI(linearDistance, serviceType);
    }
  };

  const googleDistanceAPI = origin => {
    let originCoordinates = [];
    origin?.forEach(element => {
      originCoordinates.push({ lat: element.location?.latitude, lng: element.location?.longitude });
    });
    getDistanceFromGoogleMatrix(
      originCoordinates,
      [{ lat: userLocation.userLat, lng: userLocation.userLong }],
      getGoogleApiResponse,
    );
  };

  const getGoogleApiResponse = ({ allStoreDistance, originAddressText }) => {
    const serviceType = getDispositionTypeOnAPIFormat(dispositionType.toUpperCase());

    //merge getGoogleApiResponse with nearBystores
    const googleApiMergedStores = mergeStoreData(allStoreDistance, nearByStores);

    //sort the merged stores
    const getSortedNearbyStoresPayload = {
      stores: googleApiMergedStores,
      numberOfStores: getTernaryValue(
        dispositionType.toUpperCase() === DISPOSITION_KEYS.DELIVERY,
        numOfStoresToShowDelivery,
        storelocatormaxreturncount,
      ),
      disposition: serviceType,
      distanceMetrics: distanceMetrics,
      driveTime: maxDriveTimeMins,
      distanceInMtrs: getTernaryValue(
        dispositionType?.toUpperCase() === DELIVERY,
        maxDeliveryDistanceMtrs,
        getTernaryValue(
          dispositionType.toUpperCase() === DISPOSITION_KEYS.PICKUP,
          maxPickupDistanceMtrs,
          maxCateringDistanceMtrs,
        ),
      ),
    };
    const sortedNearBystores = geoLocation.getSortedNearbyStores(getSortedNearbyStoresPayload);
    sortedNearBystores?.length > 0 && callStatusAPI(sortedNearBystores, serviceType);
  };

  const mergeStoreData = (storeDataOne, storeDataTwo) => {
    return storeDataTwo?.map((storeTwo, index) => {
      return { ...storeTwo, distance: storeDataOne[index] };
    });
  };

  const callStatusAPI = (storeList, serviceType) => {
    const dataList = createPayloadForStatusCall(storeList, serviceType, null, shouldCheckDropOffAddress);
    const statusCallPayload = {
      data: dataList,
      store: storeList,
      tenantId: tenantId,
      setStatusFlag: false,
      isFavoritePage: false,
    };
    dispatch(getBulkStoreStatus(statusCallPayload));
  };

  useEffect(() => {
    getUserFavLatLong({ userLat: userLocation.userLat, userLong: userLocation.userLong });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favouriteStores.length, userLocation]);

  const getUserFavLatLong = userPosition => {
    const getStoreInfoFromStorage = localStorage.getItem(LOCAL_STORAGE_KEYS.STORE_INFO);
    const storeInfo =
      getStoreInfoFromStorage && getStoreInfoFromStorage !== undefined && JSON.parse(getStoreInfoFromStorage);
    const defaultAddress = savedAddresses?.length ? savedAddresses.filter(obj => obj.isPrimary) : [];
    const originInfo = storeInfo && localized ? storeInfo : defaultAddress?.length && defaultAddress[0];
    calculateStoreDistance(
      originInfo?.location?.latitude,
      originInfo?.location?.longitude,
      favouriteStores,
      getAllSortedFavStoresData,
    );
  };

  const getAllSortedFavStoresData = allSortedFavStoreData => {
    const serviceType = getTernaryValue(dispositionType?.toUpperCase() === PICKUP, PICK_UP, dispositionType);
    const mappedStoreData = allSortedFavStoreData?.map(store => ({
      availableServicesPerChannel: store?.availableServicesPerChannel,
      distance: {
        distance: store?.distance,
      },
      duration: store?.duration,
      id: store?.storeBasic?.id,
      name: store?.storeBasic?.dname,
      amenities: store?.storeBasic?.amenities,
      addresses: store?.storeBasic?.address,
      additionalAttributes: store?.storeBasic?.additionalProperties,
      location: store?.storeBasic?.location,
    }));
    const dataList = createPayloadForStatusCall(mappedStoreData, serviceType, null, shouldCheckDropOffAddress);
    const statusCallPayload = {
      data: dataList,
      store: mappedStoreData,
      tenantId: tenantId,
      setStatusFlag: false,
      isFavoritePage: false,
    };
    !findAKFC && dispatch(getFavoriteBulkStoreStatus(statusCallPayload));
  };

  //validate stores getting from status call and get final stores
  const filterStatusCallResponse = storeList => {
    const finalStores = filterStores(storeList, enableClickCollectScheduleOrder);
    seteligibleStoreData(finalStores);
    userOrderStateDispatch({ type: SET_ELIGIBLE_STORE, value: { eligibleStore: finalStores } });
    localStorage.setItem(LOCAL_STORAGE_KEYS.ELIGIBLE_STORE, JSON.stringify(finalStores));
  };

  const orderModeGlobal = (
    <SearchStore
      singInClickhandler={singInClickhandler}
      formContent={formContent}
      storeData={storeData}
      onStoreSelectFinish={onStoreSelectFinish}
      eligibleStoreData={eligibleStoreData}
      storeCardLimit={storeCardLimit}
      userPositionHandler={getUserLatLong}
      currentMarket={currentMarket}
      dispositionType={dispositionType?.toUpperCase()}
      seteligibleStoreData={seteligibleStoreData}
      storeSelection={storeSelection}
      eligibleFavoriteStoreData={eligibleFavoriteStoreData}
      findAKFC={findAKFC}
      finAKFCContentData={finAKFCContentData}
      isMobile={isMobile}
    />
  );
  // project the store results in modal
  const searchStoreInsideModal = (
    <SearchStoreInsideModal
      handleClose={handleClose}
      orderModeTypeItem={orderModeGlobal}
      // headerText={translateWithI18Next(modalHeaderTitle)}
      headerText={translateWithI18Next(headerTitle)}
      handleGoBack={handleGoBackGlobal}
      modalTitleId='search-store'
      className={`search-store-global-container ${getAndCheck(
        isCateringDisposition(dispositionType),
        'catering-modal',
      )}`}
      backDataTestId='back-btn-global-modal-id'
    />
  );
  return userOrderState?.findAKFC ? orderModeGlobal : searchStoreInsideModal;
};

// Defaults from defaults json file
SearchStoreModule.defaultProps = SEARCHSTORE_MODULE_DATA;

export default SearchStoreModule;
